import { apiBreeder } from 'utilities/http/api/dogPark/apiBreeder';
import { BreedersSearchByType } from 'dogpark/types';

export const getBreederAdminUsers = async (
  searchBy: BreedersSearchByType | undefined,
  searchValue: string | undefined,
) => {
  if (searchBy && searchValue) {
    const respSearch = await apiBreeder.getBreederAdminUser(Number(searchValue));

    if (!respSearch.isOk) {
      throw Error(`Breeder Admin id ${searchValue} not found`);
    }

    return [respSearch.json.breederAdminUser];
  } else {
    const resp = await apiBreeder.getBreederAdminUsers();

    if (!resp.isOk) {
      throw Error('Error on fetch breeder admins');
    }

    return resp.json.breederAdminUsers.data;
  }
};

export const getBreederAdminManagedBreeders = async (userId: number) => {
  const resp = await apiBreeder.getBreederAdminManagedBreeders(userId);

  if (!resp.isOk) {
    throw Error('Error on fetch breeder admins managed breeders');
  }

  return resp.json.managedBreeders;
};
